import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'dva';
import Header from 'components/Header';
import Loading from 'components/Loading';
import { useEffectLoading } from '@/hooks';
import {
  SearchFilterTableList,
  ContentBlockTitle,
  ServiceGuidelines,
  ServiceTimeline,
  MealList,
} from '@/pages/railSetMeal/components';
import { getLang } from '@/pages/railSetMeal/common/util';
import { namespace } from '@/pages/railSetMeal/common/enum';
import { getShowTopBar } from '@/utils/getValue';
import styles from './index.less';

import rail from '@/assets/images/rail.png';
import foods from '@/assets/images/foods.png';
import qrCode from '@/assets/images/qrCode.png';

const RailSetMeal = (props: Record<string, any>) => {
  const dispatch = useDispatch();
  const showTopBar = getShowTopBar();
  const loading = useEffectLoading(namespace, [
    'getNetworkTrainList',
    'getNetworkRailCombosetList',
  ]);
  const networkTrainList = useSelector((state: any) => state[namespace].networkTrainList); // 获取车次列表
  const networkRailCombosetList = useSelector(
    (state: any) => state[namespace].networkRailCombosetList,
  ); // 获取套餐组合列表
  const { language, agentId } = props?.location?.query;

  const searchTableColumns = [
    {
      title: getLang('车次'),
      dataIndex: 'code',
    },
    {
      title: getLang('始发站'),
      dataIndex: 'startStation',
    },
    {
      title: getLang('终点站'),
      dataIndex: 'endStation',
    },
  ];

  const serviceTimelineItems = [
    {
      label: <img src={rail} />,
      content: '1、 查询所乘车次是否提供餐食服务及套餐类型',
    },
    {
      label: <img src={foods} />,
      content: '2、 移步至列车餐吧或向推车售货员咨询所需套餐库存是否充足',
    },
    {
      label: <img src={qrCode} />,
      content:
        '3、 告知售货员套餐类型及份数，出示凭证，核销通过后即可领取餐食',
    },
  ];

  // 获取车次列表
  const fetchNetworkTrainList = () => {
    dispatch({
      type: `${namespace}/getNetworkTrainList`,
      payload: {
        language,
        agentId,
      },
    });
  };

  // 获取高铁套餐接口
  const fetchNetworkRailCombosetList = () => {
    dispatch({
      type: `${namespace}/getNetworkRailCombosetList`,
      payload: {
        language,
        agentId,
      },
    });
  };

  useEffect(() => {
    fetchNetworkTrainList();
    fetchNetworkRailCombosetList();
  }, []);

  return (
    <Loading loading={loading}>
      <Header title={getLang('高铁列车餐食')} />
      <div
        className={styles.mainContent}
        style={{
          paddingTop: showTopBar ? '1rem' : '0',
        }}
      >
        <SearchFilterTableList
          placeholder={getLang('请输入车次进行进行查询')}
          cancelText={getLang('取消')}
          dataSource={networkTrainList}
          columns={searchTableColumns}
          letter={getLang('当前搜索车次暂未提供服务，敬请期待')}
          contentFilteringField={['code']}
        />

        <ContentBlockTitle className={styles.mainContentBorder} title={getLang('使用流程')}>
          <ServiceTimeline items={serviceTimelineItems} />
        </ContentBlockTitle>

        <ContentBlockTitle className={styles.mainContentBorder} title={getLang('套餐内容')}>
          <MealList list={networkRailCombosetList}/>
        </ContentBlockTitle>

        <ContentBlockTitle className={styles.mainContentBorder} title={getLang('服务须知')}>
          <ServiceGuidelines>
            1.&nbsp;&nbsp;龙腾出行精选铁路局或供餐公司车餐（包括但不限于餐食、休闲食品、饮品…）搭配/组合形成高铁列车餐食权益，为龙腾客户的用户提供方便快捷、干净卫生、丰富美味的旅途配餐服务，纵享家乡（或地域）味道及星级服务体验。
            <br />
            2.&nbsp;&nbsp;当前覆盖济南局近300趟车次（项目上线初期，为保障服务体验，仅放出部分列车/车次）。具体可使用列车（车次）见页面上方，您可通过搜索，查询所乘列车（车次）是否提供列车餐食服务，详情以现场提供为准。
            <br />
            3.&nbsp;使用1次高铁列车餐食权益兑换1份餐食，如需多份餐食则根据使用规则叠加。
            <br />
            4.&nbsp;核销成功后即可领取餐食，如因列车信号影响，请您谅解并耐心等待。
            <br />
            5.&nbsp;如遇列车餐食全部套餐售罄情况，现场则无法提供服务，或在下一补给点完成补给后提供服务，谢谢您的理解。
          </ServiceGuidelines>
        </ContentBlockTitle>
      </div>
    </Loading>
  );
};

export default RailSetMeal;
